import { fetcher } from '../fetcher';
import type { LoginProps } from '../types';
import { userSchema } from '../schemas';

export const authService = {
  login: (payload: LoginProps) => {
    return fetcher(`/login`, {
      method: 'POST',
      body: {
        ...payload,
        remember: true,
      },
    });
  },
  getUser: () => {
    return fetcher(`/me`, {
      method: 'GET',
      schema: userSchema,
    });
  },
  logout: () => {
    return fetcher(`/logout`, {
      method: 'POST',
    });
  },
  getCsrf: () => {
    return fetcher(`/csrf-cookie`, {
      method: 'GET',
    });
  },
};
